var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","text":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.load()}}},[_vm._v("Date Time")])
}
var staticRenderFns = []

export { render, staticRenderFns }